<div class="relative w-full date-picker-container">
    @if (label) {
    <div class="flex justify-between items-center">
        <label class="block font-poppins font-medium text-[12px] leading-[18px] text-secundary text-left">{{ label }}</label>
    </div>
    }
<div class="w-full">
    <div class="relative w-full" [class.mt-1]="!!label" cdkOverlayOrigin #dateTrigger="cdkOverlayOrigin">
        <input
            [readonly]="true"
            type="text"
            [value]="displayValue"
            [placeholder]="placeholder"
            (click)="toggleCalendar()"
            [ngClass]="{
                'h-12 py-3': true,
                'border-negative focus:border-negative border-[2px]': isInvalid,
                'border-soft-gray border-[1px]': !isInvalid,
                'placeholder:text-text-primary bg-secundary-b1100 border-none font-medium': isReadOnly || isDisabled,
                'cursor-pointer': !isReadOnly && !isDisabled
            }"
            class="w-full rounded-2xl text-text-primary text-[16px] placeholder:text-text-placeholder placeholder:font-normal focus:outline-none focus:border-[2px] px-4 pr-12"
        />

        <i class="fi fi-rr-calendar absolute right-4 top-1/2 -translate-y-1/2 text-text-secondary pointer-events-none flex items-center justify-center"></i>

        <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="dateTrigger"
            [cdkConnectedOverlayOpen]="isOpen() && !isReadOnly && !isDisabled"
            [cdkConnectedOverlayHasBackdrop]="false"
            [cdkConnectedOverlayPositions]="[
                { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
                { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -8 }
            ]"
            (overlayOutsideClick)="onOverlayOutsideClick($event)">
            <div class="date-picker-container z-50 bg-white rounded-lg border border-[rgba(154,168,188,0.2)] p-3 w-[261px]"
                 style="box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.16);">
                <div class="flex items-center justify-between h-10 mb-2">
                    <div class="flex items-center justify-start gap-1">
                        <!-- Mes Dropdown -->
                        <div class="relative">
                            <button type="button" (click)="toggleMonthDropdown()" 
                                    class="px-2 py-1 text-[#27313F] text-base font-medium font-lexend rounded-2xl border-none bg-transparent focus:outline-none cursor-pointer">
                                {{ months[currentMonth] }}
                            </button>
                            @if (showMonthDropdown) {
                            <ul class="absolute z-[100] mt-1 bg-white border border-soft-gray rounded-2xl shadow overflow-y-auto max-h-[200px] w-[150px]">
                                @for (month of months; track $index) {
                                <li (click)="selectMonth($index)" 
                                    [id]="'month-' + $index"
                                    class="px-4 py-2 cursor-pointer hover:bg-primary-g300 hover:text-[#FFFFFF]">
                                    {{ month }}
                                </li>
                                }
                            </ul>
                            }
                        </div>
                        <!-- Año Dropdown -->
                        <div class="relative">
                            <button type="button" (click)="toggleYearDropdown()" 
                                    class="px-1 py-1 text-[#27313F] text-base font-medium font-lexend rounded-2xl border-none bg-transparent focus:outline-none cursor-pointer">
                                {{ currentYear }}
                            </button>
                            @if (showYearDropdown) {
                            <ul class="absolute z-[100] mt-1 bg-white border border-soft-gray rounded-2xl shadow overflow-y-auto max-h-[200px] w-[80px]">
                                @for (year of years; track year) {
                                <li (click)="selectYear(year)" 
                                    [id]="'year-' + year"
                                    class="px-4 py-2 cursor-pointer hover:bg-primary-g300 hover:text-[#FFFFFF]">
                                    {{ year }}
                                </li>
                                }
                            </ul>
                            }
                        </div>
                    </div>
                    <div class="flex items-center gap-0">
                        <button type="button" (click)="previousMonth()" 
                                class="p-0 rounded-2xl hover:bg-gray-100 transition-colors w-6 h-6 flex items-center justify-center">
                            <i class="fi fi-rr-arrow-small-up text-[#1A212B]"></i>
                        </button>
                        <button type="button" (click)="nextMonth()" 
                                class="p-0 rounded-2xl hover:bg-gray-100 transition-colors w-6 h-6 flex items-center justify-center">
                            <i class="fi fi-rr-arrow-small-down text-[#1A212B]"></i>
                        </button>
                    </div>
                </div>

                <div class="flex justify-center items-center mb-2">
                    @for (day of daysOfWeek; track day) {
                    <div class="flex flex-col justify-center items-center w-8 h-8 min-w-[32px] max-w-[32px] min-h-[32px] max-h-[32px]">
                        <span class="font-lexend font-medium text-base leading-6 text-[#1A212B]">{{ day }}</span>
                    </div>
                    }
                </div>

                <div class="flex flex-col items-center gap-0">
                    @for (week of getWeeks(); track $index) {
                    <div class="flex justify-center items-center w-full">
                        @for (day of week; track $index) {
                        <button type="button"
                            (click)="selectDate(day)"
                            [disabled]="!day.isCurrentMonth"
                            [ngClass]="{
                                'bg-[#1A212B] text-[#F6F8FB] rounded-lg': day.isSelected,
                                'text-[#1A212B]': day.isCurrentMonth && !day.isSelected,
                                'text-[#728197]': !day.isCurrentMonth,
                                'hover:bg-gray-100': !day.isSelected && day.isCurrentMonth,
                                'rounded-2xl': !day.isSelected
                            }"
                            class="flex flex-col justify-center items-center w-8 h-8 min-w-[32px] max-w-[32px] min-h-[32px] max-h-[32px] transition-colors cursor-pointer">
                            <span class="font-lexend font-normal text-sm leading-5">{{ day.day }}</span>
                        </button>
                        }
                    </div>
                    }
                </div>

                <div class="flex justify-end items-start gap-4 mt-2 h-10">
                    <button type="button" (click)="clearDate()" 
                            class="flex-1 flex justify-center items-center px-4 py-2 rounded-2xl hover:bg-gray-50 transition-colors">
                        <span class="font-poppins font-medium text-base leading-6 text-[#27313F]">Borrar</span>
                    </button>
                    <button type="button" (click)="selectToday()" 
                            class="flex-1 flex justify-center items-center px-4 py-2 rounded-2xl transition-colors">
                        <span class="font-poppins font-medium text-base leading-6 text-[#4FD1C5]">Hoy</span>
                    </button>
                </div>
            </div>
        </ng-template>
    </div>

    @if (assistiveText) {
    <div class="flex justify-between items-center pl-4 mt-1">
        <label class="block font-poppins font-normal text-xs leading-[18px] text-[#757575]">{{ assistiveText }}</label>
    </div>
    }
</div>
    @if (isInvalid && showError) {
    <div class="flex items-center ml-3 mt-1">
        <i class="fi fi-sr-triangle-warning text-negative mr-1 text-[13px] flex-shrink-0 h-4 flex"></i>
        <p class="font-poppins font-normal text-[12px] text-start leading-tight text-[#B1000F]">
            {{ control.errors | formError }}
        </p>
    </div>
    }
</div>
